import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import styles from './Login.scss';
import { requestPasswordReset, resetPassword } from '~/modules/auth';
import ChangePasswordForm from '~/components/ChangePasswordForm';

const PasswordReset = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  return (
    <div>
      <h1>
        <FormattedMessage id="PasswordReset__Title" defaultMessage="Forgot your password?" />
      </h1>
      <form onSubmit={async (e) => {
        e.preventDefault();
        setLoading(true);

        await dispatch(requestPasswordReset(e.target.email.value, window.location.href));

        return setLoading(false);
      }}
      >
        <label htmlFor="ResetEmail">
          <FormattedMessage id="PasswordReset__PromptEmail" defaultMessage="Enter your email address" />
          <input name="email" type="email" id="ResetEmail" />
        </label>

        <p>
          <FormattedMessage id="PasswordReset__SubText" defaultMessage="We'll send you a link to reset your password" />
        </p>

        <button disabled={loading} className={styles.Login__Button} type="submit">
          {loading ? 'Sending...' : 'Send'}
        </button>
      </form>
    </div>
  );
};

export default () => {
  const dispatch = useDispatch();
  const { isSignedIn } = useSelector(state => state.currentUser);

  const query = new URLSearchParams(useLocation().search);
  const isResetPassword = query.get('reset_password');

  const onSubmit = (values, actions) => {
    return dispatch(resetPassword(values.newPassword, values.confirmPassword))
      .then(json => {
        actions.setSubmitting(false);
      });
  };

  if (isSignedIn && isResetPassword) {
    return (
      <ChangePasswordForm
        confirmCurrent={false}
        onSubmit={onSubmit}
      />
    );
  }

  return <PasswordReset />;
};
